import {connect} from 'react-redux'
import Page from '../components/Page.jsx'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    active: state.page && state.page.active !== undefined ? state.page.active : false
  }
}

// Map Redux actions to component props
// function mapDispatchToProps (dispatch) {
//   return {
//     onPlayTrack: (i) => dispatch(playTrack(i))
//   }
// }

// Connected Component
const PageContainer = connect(
  mapStateToProps
)(Page)

export default PageContainer
